import { cn } from "@/lib/utils";

export type ScreenplayElementType =
  | "slugline"
  | "action"
  | "character"
  | "parenthetical"
  | "dialogue"
  | "transition";

export type ScreenplayElementData = {
  type: ScreenplayElementType;
  text: string;
};

const elementClasses: Record<ScreenplayElementType, string> = {
  slugline:
    "font-bold uppercase tracking-wide text-zinc-700 dark:text-amber/90",
  action: "text-zinc-600 dark:text-white/65",
  character: "mt-2.5 text-center uppercase text-zinc-800 dark:text-white/90",
  parenthetical:
    "mx-auto w-[52%] pl-3 text-center text-zinc-500 dark:text-white/45",
  dialogue: "mx-auto w-[62%] text-zinc-700 dark:text-white/75",
  transition: "text-right uppercase text-zinc-600 dark:text-white/60",
};

type ScreenplayElementProps = {
  element: ScreenplayElementData;
  className?: string;
};

export const ScreenplayElement = ({
  element,
  className,
}: ScreenplayElementProps) => (
  <p className={cn(elementClasses[element.type], className)}>{element.text}</p>
);
